import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';

@Pipe({
  name: 'assetUrl',
})
export class AssetUrlPipe implements PipeTransform {
  transform(filePath: string | undefined): string {
    if (!filePath || filePath === '') return '/assets/No-Image-Placeholder.png';
    filePath = filePath[0] !== '/' ? `/${filePath}` : filePath;
    filePath = filePath.replace(/\/\//g, '/');
    return `${environment.s3_url}${filePath}`;
  }
}
